export default __webpack_public_path__ + "static/259-80ab796252af8e70480f23bc4f354544.gif";